import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  API_CONFIGURATION_TOKEN,
  ApiConfiguration
} from '../tokens/api.configuration';
import { BaseApi } from '../abstracts';
import { JwtService } from '@ecosure-suite/shared/util-auth';

@Injectable({
  providedIn: 'root'
})
export class KeycloakAuthApiService extends BaseApi {
  constructor(
    @Inject(API_CONFIGURATION_TOKEN) configuration: ApiConfiguration,
    http: HttpClient, jwtService: JwtService,
  ) {
    super(http, jwtService);
    this.server = configuration.keycloak_uri;
  }
}
